export default function schemaPrice(string) {
  const price = string
    .replace(/[^0-9]/g, " ")
    .split(" ")
    .filter((word) => word.length > 0)[0];

  return typeof price !== "undefined" ? price : "";
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schemaPrice.js